import React from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet } from 'react-router-dom'; 
import { selectEmail } from '../../redux/slice/authSlice';
import './adminDashboard.scss'; 
const AdminDashboard = () => { 
  const userEmail = useSelector(selectEmail);
  
  return (
    <div className="admin-dashboard">
        <header className="admin-header">
          <h1>Admin Dashboard</h1>
          <p>Welcome, {userEmail}!</p>
          <nav className="admin-nav"> 
            <Link to="/admin/users" className="admin-nav-button">User List</Link>
            <Link to="/admin/tasks" className="admin-nav-button">All Tasks</Link> 
            <button className="logout-button">Logout</button>
          </nav>
        </header>

      <main className="admin-content">
        <Outlet />
      </main>
      <footer className="admin-footer">
        <p>&copy; {(new Date()).getFullYear()} Your Company. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default AdminDashboard;
